export const getCustomerMasterList = state => {
    return state.list
}

export const getCustomerMasterDataProps = state => {
    return state.props
}

export const getCustomerMasterAutocompleteList = state => {
    return state.autocomplete_list
}



// WEBPACK FOOTER //
// ./src/store/modules/customerMaster/getters.js